import { render } from "./MaterialInterface.vue?vue&type=template&id=f159d214"
import script from "./MaterialInterface.vue?vue&type=script&lang=js"
export * from "./MaterialInterface.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__